var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.link)?_c('div',{staticClass:"button_wrapper"},[_c('button',{attrs:{"type":"submit"}},[(_vm.loading)?_c('span',{staticClass:"btn_loader"}):_vm._e(),_vm._t("default")],2)]):_c('div',{staticClass:"button_wrapper"},[_c('router-link',{attrs:{"to":_vm.to}},[(_vm.loading)?_c('span',{staticClass:"btn_loader"}):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }